import React from 'react';
import { BookOpenIcon, CheckCircle2Icon } from 'lucide-react';
import { motion } from 'framer-motion';
const TOMOS = [{
  num: '01',
  title: 'Verb to Be & Classroom Basics',
  desc: 'Teoría express + worksheets + speaking + evaluación + clave.'
}, {
  num: '02',
  title: 'Articles, Plurals & There is/are',
  desc: 'Artículos, plurales, there is/are + prepositions of place (bonus puente).'
}, {
  num: '03',
  title: 'Pronouns & Possession Toolkit',
  desc: 'Possessive adjectives/pronouns, object pronouns, reflexives + práctica multinivel.'
}, {
  num: '04',
  title: 'Adjectives & Comparisons Pack',
  desc: 'Adjectives + comparatives + superlatives + equatives + speaking teen-friendly.'
}, {
  num: '05',
  title: 'Present Tenses + Modals',
  desc: 'Simple present, present continuous, contraste + can/should/must/have to.'
}, {
  num: '06',
  title: 'Past/Future/Perfect + Bridge B1→B2',
  desc: 'Simple past, future, present perfect + indefinite pronouns + intro reported/conditionals.'
}];
export function QueIncluye() {
  return <section className="py-8 bg-orange-50/50" data-id="element-201">
      <div className="max-w-5xl mx-auto px-4" data-id="element-202">
        <div className="text-center mb-6" data-id="element-203">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase" data-id="element-204">
            ¿Qué <span className="text-orange-500" data-id="element-205">incluye?</span>
          </h2>
          <div className="w-24 h-2 bg-orange-400 mx-auto mt-6 rounded-full" data-id="element-206"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-207">
          {TOMOS.map((tomo, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white p-6 rounded-2xl shadow-lg border-2 border-gray-100 hover:border-orange-300 hover:shadow-xl transition-all flex gap-4 items-start group relative overflow-hidden" data-id="element-208">
              {/* Big number background */}
              <div className="absolute -top-4 -right-2 text-[100px] font-black text-gray-100 leading-none select-none pointer-events-none group-hover:text-orange-100 transition-colors" data-id="element-209">
                {tomo.num}
              </div>

              <div className="bg-orange-500 p-3 rounded-xl flex-shrink-0 shadow-md" data-id="element-210">
                <BookOpenIcon className="w-6 h-6 text-white" data-id="element-211" />
              </div>
              <div className="relative z-10" data-id="element-212">
                <p className="text-xs font-black text-orange-500 uppercase tracking-widest mb-1" data-id="element-213">
                  TOMO {tomo.num}
                </p>
                <h3 className="font-black text-lg text-gray-900 mb-2 leading-tight" data-id="element-214">
                  {tomo.title}
                </h3>
                <p className="text-gray-600 font-medium" data-id="element-215">{tomo.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-900 text-white p-6 rounded-2xl text-center shadow-xl max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4" data-id="element-216">
          <CheckCircle2Icon className="w-8 h-8 text-orange-400 flex-shrink-0" data-id="element-217" />
          <p className="text-lg md:text-xl font-bold" data-id="element-218">
            Incluye Answer Key (clave) en cada tomo + actividades por nivel
            (A1–A2 / B1 / B2).
          </p>
        </motion.div>
      </div>
    </section>;
}